import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import companyService from '../services/companyService';
import userContactService from '../services/userContactService';
import SEO from '../components/SEO';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
    const [companyInfo, setCompanyInfo] = useState({});

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const data = await companyService.getObjectData();
                if (!alive) return;
                setCompanyInfo(data || {});
            } catch (_) {
                if (!alive) return;
                setCompanyInfo({});
            }
        })();
        return () => { alive = false; };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // 校验至少提供邮箱或电话其一
        if (!formData.email && !formData.phone) {
            alert('请至少提供邮箱或电话号码中的一种联系方式。');
            return;
        }
        try {
            const payload = {
                userName: formData.name,
                email: formData.email || '',
                phone: formData.phone || '',
                information: formData.message,
                createdAt: new Date().toISOString().replace('T', ' ').slice(0, 19),
            };
            await userContactService.create(payload);
            alert('感谢您的咨询！我们将尽快回复。');
            setFormData({ name: '', email: '', phone: '', message: '' });
        } catch (err) {
            console.error(err);
            alert('提交失败，请稍后重试。');
        }
    };

    const location = useLocation();
    
    return (
        <section className="contact-page py-5">
            <SEO
                title="聯繫我們 - 留洋教育科技公司"
                description="聯繫留洋教育科技公司，獲取專業的留學與移民諮詢服務。我們在香港和中國內地設有辦事處，為您提供一對一專業諮詢。"
                keywords="聯繫留洋,留學諮詢,移民諮詢,留學顧問,移民顧問,聯繫方式"
                canonical={`https://liuyanghorizon.com${location.pathname}`}
                ogImage="https://liuyanghorizon.com/images/logo.png"
            />
            <div className="container">
                <h1 className="text-center mb-5 contact-title">联系我们</h1>
                <div className="row g-4 align-items-stretch">
                    <div className="col-md-6 d-flex">
                        <div className="contact-card flex-grow-1">
                            <h5 className="mb-3">公司联系信息</h5>
                            <div className="mb-3 contact-info-block">
                            <strong>地址</strong>
                            <ul className="mb-0 ps-3 contact-info-list">
                                {companyInfo.chinaAddress && (<li>中国：{companyInfo.chinaAddress}</li>)}
                                {companyInfo.hkAddress && (<li>香港：{companyInfo.hkAddress}</li>)}
                            </ul>
                            </div>
                            <div className="mb-3 contact-info-block">
                            <strong>电话</strong>
                            <ul className="mb-0 ps-3 contact-info-list">
                                {companyInfo.chinaCustomerServiceNo && (
                                    <li>中国客服：<a href={`tel:${companyInfo.chinaCustomerServiceNo}`}>{companyInfo.chinaCustomerServiceNo}</a></li>
                                )}
                                {companyInfo.hkCustomerServiceNo && (
                                    <li>香港客服：<a href={`tel:${companyInfo.hkCustomerServiceNo}`}>{companyInfo.hkCustomerServiceNo}</a></li>
                                )}
                                {companyInfo.chinaContactNo && (
                                    <li>中国直线：<a href={`tel:${companyInfo.chinaContactNo}`}>{companyInfo.chinaContactNo}</a></li>
                                )}
                                {companyInfo.hkContactNo && (
                                    <li>香港直线：<a href={`tel:${companyInfo.hkContactNo}`}>{companyInfo.hkContactNo}</a></li>
                                )}
                            </ul>
                            </div>
                            <div className="mb-0 contact-info-block">
                            <strong>邮箱</strong>
                            <ul className="mb-0 ps-3 contact-info-list">
                                {companyInfo.email1 && (<li><a href={`mailto:${companyInfo.email1}`}>{companyInfo.email1}</a></li>)}
                                {companyInfo.email2 && (<li><a href={`mailto:${companyInfo.email2}`}>{companyInfo.email2}</a></li>)}
                            </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 d-flex">
                        <form onSubmit={handleSubmit} className="contact-card contact-form flex-grow-1">
                            <div className="mb-3">
                                <label className="form-label">姓名</label>
                                <input type="text" className="form-control" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">邮箱（可选）</label>
                                <input type="email" className="form-control" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} placeholder="example@domain.com" />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">电话（可选）</label>
                                <input type="tel" className="form-control" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} placeholder="请输入您的联系电话" />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">消息</label>
                                <textarea className="form-control" rows="5" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} required />
                            </div>
                            <button type="submit" className="btn btn-primary w-100 w-md-auto">发送</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;